import React, { Component } from "react";
import moment from 'moment'
import 'moment-timezone';
import FullCalendar from '@fullcalendar/react'
import { formatDate } from '@fullcalendar/core'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import listPlugin from '@fullcalendar/list'
import interactionPlugin from '@fullcalendar/interaction'
import './week.css'
class WeekCalendar extends Component {
    state = {
        weekendsVisible: true,
    }
    render() {
        const { upcomingEventsList, events, numEvents } = this.props;
        return (
            <div className='cldtd_calendar_card_Week'>
                <div className='cldtd_calendar_card_main_Week'>
                    <FullCalendar
                        plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                        headerToolbar={{
                            left: '',
                            center: 'title',
                            right: ''
                        }}
                        initialView='dayGridWeek'
                        displayEventTime={true}
                        events={events}
                        eventColor="#D1A273"
                        timeFormat='H'
                        dayMaxEventRows={2}
                        slotDuration='01:00'
                    />
                </div>
                {this.renderSidebar()}
            </div>
        )
    }
    getVisibleRange() {
        const events = this.props.upcomingEventsListweek;
        if (!events || events.length === 0) return undefined;
        const dates = events.map(e => new Date(e.start));
        const minDate = new Date(Math.min(...dates));
        const maxDate = new Date(Math.max(...dates));
        maxDate.setDate(maxDate.getDate() + 1);
        return {
            start: minDate.toISOString().split('T')[0],
            end: maxDate.toISOString().split('T')[0]
        };
    }
    renderSidebar() {
        const { upcomingEventsList, events, numEvents } = this.props;
        const visibleRange = this.getVisibleRange();
        return (
            <div className='cldtd_calendar_card_sidebar_Week'>
                <div className='cldtd_calendar_card_sidebar_section'>
                    <div className="cldtd_calendar_card_sidebar_date_week">Upcoming Events</div>
                    <div className="cldtd_calendar_card_eventSection">
                        <FullCalendar
                            plugins={[listPlugin]}
                            headerToolbar={{
                                left: '',
                                center: '',
                                right: ''
                            }}
                            initialView='list'
                            timeZone='local'
                            dayMaxEventRows={1}
                            events={this.props.upcomingEventsListweek}
                            visibleRange={visibleRange}
                        />
                    </div>

                </div>
            </div>
        )
    }
}


export default WeekCalendar

